import { ExInput } from '@boomi/exosphere';

const Scopes = ({ scopes }: { scopes: string[] }) => {
    return scopes.length > 0 ? (
        <ExInput
            label="Scopes"
            type="text"
            value={scopes.join(' ')}
            disabled={true}
            helpText="Connect will authorize the user with these scopes. They should be enabled in your OAuth client."
        />
    ) : null;
};

export default Scopes;
